export const SAMPLE_TYPES_CODES = Object.freeze({
	solo: 'solo',
	bulk: 'bulk',
	herd: 'herd',
	comp: 'comp'
})

export const VIEW_TYPES = Object.freeze({
	MOST_RECENT: 'recent',
	MONTHLY: 'monthly'
})

export const MONTHS = [
	{value: 0, name: 'January'},
	{value: 1, name: 'February'},
	{value: 2, name: 'March'},
	{value: 3, name: 'April'},
	{value: 4, name: 'May'},
	{value: 5, name: 'June'},
	{value: 6, name: 'July'},
	{value: 7, name: 'August'},
	{value: 8, name: 'September'},
	{value: 9, name: 'October'},
	{value: 10, name: 'November'},
	{value: 11, name: 'December'}
]

export const TEST_TYPES = Object.freeze({
	blood_agar_plate: 'BAP',
	myco: 'MYCO',
	both: 'BOTH',
	full: 'FULL',
	water: 'Water',
	standard_plate: 'SPC',
	lab_pasteurization: 'LPC',
	coliform: 'Coli',
	preliminary_incubation: 'PI',
	myco_broth: 'Myco Broth',
	component: 'BF/P/SCC',
	salmonella: 'Salmonella',
	culturettes: 'Culturettes',
	bedding: 'Bedding',
	lost_in_transit: 'Lost In Transit'
})

export const DATE_FORMATS = Object.freeze({
	table: 'table',
	form: 'form',
	db: 'db'
})

export const HEADER_TEXT_CODES = Object.freeze({
	EMPHASIZE: '!',
	ITALICS: '#',
	OTHER_PRESENT: '&'
})

export const CELL_SIZES = Object.freeze({
	small: 'small-cell',
	medium: 'medium-cell',
	large: 'large-cell'
})